module.exports = __webpack_public_path__ + "img/CONVERSABAN.b20a61dd.png";